import { Component, DoCheck, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { TableCellComponent } from '@captiveaire/table';
import { IDeviceStatusListSummary } from '../shared/models/device-status-list-summary.interface';
import { FirmwareVersionService } from '../shared/services/firmware-version.service';

@Component({
    selector: 'dl-device-status-firmware-version-cell',
    templateUrl: './device-status-firmware-version-cell.component.html'
})
export class DeviceStatusFirmwareVersionCellComponent extends TableCellComponent implements DoCheck, OnInit {
    public static $name: string = 'clDeviceStatusFirmwareVersionCell';
    @Input() public item: IDeviceStatusListSummary;

    public formGroup: FormGroup;
    public firmwareVersionFormControl: FormControl;

    firmwareVersions: any[];
    isLoaded: boolean = false;
    protected selectedFirmwareVersion: any;

    private lastIsEditable: boolean;

    constructor (
        private firmwareVersionService: FirmwareVersionService,
    ) {
        super();
    }

    public ngOnInit() {
        this.formGroup = new FormGroup({});
        this.firmwareVersionFormControl = new FormControl(this.item.embeddedVersion, []);
        this.formGroup.addControl('firmwareVersions', this.firmwareVersionFormControl);
    }

    public ngDoCheck() {
        if (!this.lastIsEditable && this.isEditable) {
            this.firmwareVersionService.getList(this.item.category).then(res => {
                this.firmwareVersions = res;
                this.isLoaded = true;
            });
        }

        if (this.isEditable) {
            this.firmwareVersionFormControl.enable();
        } else {
            this.firmwareVersionFormControl.disable();
        }

        this.lastIsEditable = this.isEditable;
    }

    public updateFirmwareVersion() {
        this.item.embeddedVersion = this.firmwareVersionFormControl.value;
    }

    get isEditable(): boolean {
        return this.item.$isInEditMode
            && this.item !== null;
    }
}
